import { CommonModule } from '@angular/common'
import { Component, ElementRef, Input, ViewChild } from '@angular/core'
import { RouterModule } from '@angular/router'
import { ConfettiService } from '@app/core/_services/confetti.service'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { faGift } from '@fortawesome/pro-light-svg-icons'
import { faGift as faGiftSolid } from '@fortawesome/pro-solid-svg-icons'
import { TooltipModule } from 'primeng/tooltip'

@Component({
    selector: 'fm-refer-link',
    imports: [FaIconComponent, CommonModule, RouterModule, TooltipModule],
    templateUrl: './refer-link.component.html',
    styleUrl: './refer-link.component.scss',
})
export class ReferLinkComponent {
    @ViewChild('referIcon') referIcon!: ElementRef<HTMLCanvasElement>

    @Input() emphasizeAnimation = false

    public faGift = faGift
    public faGiftSolid = faGiftSolid
    public isHovered = false

    constructor(private confettiService: ConfettiService) {}

    ngOnChanges() {
        if (this.emphasizeAnimation) {
            this.confettiService.leakyConfetti(this.referIcon)
        }
    }
}
